import React from 'react'
import { GeneralBodyProps } from './GeneralBody.d'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import { GeneralBodyOptions } from '@toasttab/shared/src/utils/Contentful/richText'

const GeneralBodyModule = (generalBody: GeneralBodyProps) => {
  const bodyCss =
    'otl-general-body o-rte-text my-6 overflow-auto w-full font-serif text-lg leading-[28.8px] text-default [&>:first-child]:mt-0 [&>:last-child]:mb-0'
  return (
    <>
      {generalBody && generalBody.tableOfContentsId ? (
        <div id={generalBody.tableOfContentsId} className={bodyCss}>
          {generalBody.body?.raw &&
            renderRichText(generalBody.body, GeneralBodyOptions)}
        </div>
      ) : (
        <div className={bodyCss}>
          {generalBody.body?.raw &&
            renderRichText(generalBody.body, GeneralBodyOptions)}
        </div>
      )}
    </>
  )
}

export default GeneralBodyModule
